import React, { useState, useEffect } from 'react';
import { IoMdEye } from 'react-icons/io';
import { MdDelete } from "react-icons/md";
import { Button, Pagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ViewWarehouse from '../../../../component/b2c/models/ViewWarehouse';
import { useMyContext } from '../../../../context/MyContext';
import Swal from 'sweetalert2';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../../component/b2c/navBar/navBar';
import PaginationItem from '@mui/material/PaginationItem';
import '../../../../css/custom-scrollbar.css';
import { LuWarehouse, LuMapPin, LuPhone, LuBoxes, LuPackageSearch } from "react-icons/lu";
import axios from 'axios';
import { CgSearch } from "react-icons/cg";
import { IoClose } from "react-icons/io5";
import { Base_Url, deletewarehouse, Warehouselist } from '../../../../config/config';
import AddWarehousePopup from '../addwarehouse/AddWarehousePopup.jsx';
import { PlusIcon } from 'lucide-react';

const AllWarehouses = () => {
  const [totalOrders, setTotalOrders] = useState(0);
  const { isDarkMode } = useMyContext();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const { isToggleSidebar, setIsToggleSidebar} = useMyContext();
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const navigate = useNavigate();
  const [loadingWarehouseId, setloadingWarehouseId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  // NEW: controls the right-side "Add Warehouse" drawer
  const [isAddDrawerOpen, setIsAddDrawerOpen] = useState(false);

  // Mobile detection
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const checkScreen = () => setIsMobileView(window.innerWidth < 768);
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  useEffect(() => {
    fetchWarehouses()
  }, [page, limit]);


  const fetchWarehouses = async () => {
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    try {
      const pageNumber = Number(page) || 1;
      const limitNumber = Number(limit) || 10;
      const urlWarehouse = `${Base_Url}${Warehouselist}?page=${pageNumber}&limit=${limitNumber}`
      const response = await fetch(urlWarehouse, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cusid,
          'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      if (result.status === "SUCCESS" && Array.isArray(result.data)) {
        setWarehouses(result.data);
        setTotalOrders(result.pagination.totalItems || 0);
      } else {
        console.error('Unexpected response format:', result);
      }
    } catch (error) {
      console.error('Error fetching warehouse data:', error);
    }
  };


  const handlePaginationChange = (event, value) => {
    setPage(value);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = warehouses.slice(indexOfFirstItem, indexOfLastItem);

  const handleViewClick = (warehouse) => {
    setSelectedWarehouse(warehouse);
    setIsPopupOpen(true);
  };

  const handleClose = () => {
    setIsPopupOpen(false);
  };

  const handleNavigation = () => {
    navigate('/dashboard');
  };

  const handleDelete = async (id) => {
    setloadingWarehouseId(id);
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this deletion!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#000000',
      cancelButtonColor: '#666666',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const urldelete = Base_Url + deletewarehouse;
        try {
          const token = localStorage.getItem('token');
          const cusid = localStorage.getItem('cus_id');
          const data = {
            warehouseId: id
          };
          const response = await axios.post(urldelete, data, {
            headers: {
              token,
              cus_id: cusid,
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
          });

          if (response.data.status === "SUCCESS") {
            setWarehouses((prevWarehouses) => prevWarehouses.filter(warehouse => warehouse.id !== id));
            setTotalOrders((prev) => prev - 1);

            Swal.fire(
              'Deleted!',
              response.data.message || 'Warehouse has been deleted successfully.',
              'success'
            );
          } else {
            Swal.fire(
              'Error!',
              'Unexpected response format: ' + response.data.message,
              'error'
            );
          }
          setloadingWarehouseId(null);
        } catch (error) {
          Swal.fire(
            'Error!',
            'Error deleting warehouse: ' + error.message,
            'error'
          );
        }
      }
    });
  };


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };


  const getFilteredWarehouse = () => {
    if (!searchTerm.trim()) {
      return warehouses;
    }

    const term = searchTerm.toLowerCase();
    return warehouses.filter(warehouse => {
      return (
        (warehouse.name?.toString().toLowerCase().includes(term)) ||
        (warehouse.phone?.toLowerCase().includes(term)) ||
        (warehouse.id?.toString().toLowerCase().includes(term))
      );
    });
  };

  const displayWarehouses = getFilteredWarehouse();
      const glass =
        "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
        "border border-white/60 dark:border-white/10 " +
        "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";

  // NEW: called by AddWarehouse after a successful create
  const handleAddSuccess = () => {
    setIsAddDrawerOpen(false);
    setPage(1);
    fetchWarehouses();
  };

  // Deterministic gradient per warehouse (for avatar)
  const avatarGradients = [
    'from-pink-500 to-rose-500',
    'from-orange-500 to-amber-500',
    'from-lime-500 to-green-500',
    'from-emerald-500 to-teal-500',
    'from-cyan-500 to-sky-500',
    'from-blue-500 to-indigo-500',
    'from-violet-500 to-purple-500',
    'from-fuchsia-500 to-pink-500',
    'from-red-500 to-orange-500',
    'from-teal-500 to-cyan-500',
  ];
  const getAvatarGradient = (seed) => {
    const str = (seed || 'W').toString();
    let hash = 0;
    for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash);
    return avatarGradients[Math.abs(hash) % avatarGradients.length];
  };

  return (
    <>
      <div className={`h-screen flex flex-col overflow-hidden transition-colors duration-300 ${isDarkMode ? 'dark bg-[#0B1120]' : 'bg-white'}`}>
         <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />
       
             <NavBar />
             <div className="flex flex-1 overflow-hidden">
         {isToggleSidebar && (
                   <div
                     className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm md:hidden"
                     onClick={() => setIsToggleSidebar(false)}
                   />
                 )}
       
                 <div
                   className={`
                     fixed inset-y-0 left-0 z-50 w-64
                     ${isToggleSidebar ? "translate-x-0" : "-translate-x-full"}
                     md:static md:inset-auto md:z-auto md:translate-x-0
                     ${isToggleSidebar ? "md:w-64" : "md:w-[72px]"}
                     m-3
                     rounded-3xl
                 
                     overflow-hidden
                     transition-all
                     duration-300
                     ease-in-out
                   `}
                 >
                   <Sidebar />
                 </div>

          <div className={`flex flex-1 flex-col mb-2 w-full overflow-y-auto p-3 transition-colors duration-300 ${isDarkMode ? 'bg-[#0B1120] text-gray-200' : 'bg-gray-100'}`}>

            {/* ================= MOBILE HEADER (only < md) ================= */}
            <div className="md:hidden mb-3">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-2">
                  <div className={`flex items-center justify-center w-9 h-9 rounded-2xl border flex-shrink-0 ${isDarkMode ? 'border-indigo-500/30 bg-indigo-500/10' : 'border-indigo-200 bg-indigo-50'}`}>
                    <LuWarehouse className={`${isDarkMode ? 'text-indigo-300' : 'text-indigo-600'}`} size={18} />
                  </div>
                  <div>
                    <h1 className={`text-lg font-bold leading-tight ${isDarkMode ? 'text-white' : 'text-black'}`}>
                      All Warehouses
                    </h1>
                    <p className={`text-[10px] ${isDarkMode ? 'text-indigo-300/60' : 'text-black/40'}`}>
                      Manage every registered warehouse
                    </p>
                  </div>
                </div>
                <span className={`text-[10px] font-semibold px-2.5 py-1 rounded-full border ${isDarkMode ? 'text-indigo-300 bg-indigo-500/15 border-indigo-500/30' : 'text-indigo-600 bg-indigo-50 border-indigo-100'}`}>
                  {totalOrders} total
                </span>
              </div>

              {/* Search bar full width */}
              <div className="relative w-full mb-3">
                <CgSearch className={`absolute left-4 top-1/2 -translate-y-1/2 ${isDarkMode ? 'text-indigo-300/70' : 'text-gray-400'}`} size={18} />
                <input
                  type="text"
                  placeholder="Search by ID, phone or name..."
                  value={searchTerm}
                  onChange={handleSearchChange}
                  className={`w-full pl-11 pr-10 py-2.5 rounded-2xl outline-none text-[13px] border transition-all shadow-sm ${
                    isDarkMode
                      ? 'bg-[#141425] border-indigo-500/30 text-white placeholder-indigo-300/50 focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/20'
                      : 'bg-white border-gray-200 text-black placeholder-gray-400 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20'
                  }`}
                />
                {searchTerm && (
                  <button
                    onClick={() => handleSearchChange({ target: { value: '' } })}
                    className={`absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded-full ${isDarkMode ? 'text-indigo-300 hover:text-white' : 'text-gray-400 hover:text-black'}`}
                  >
                    <IoClose size={16} />
                  </button>
                )}
              </div>

              {/* Create Warehouse button full width */}
              <button
                onClick={() => setIsAddDrawerOpen(true)}
                className="w-full bg-gradient-to-r from-violet-600 to-indigo-600 hover:from-violet-500 hover:to-indigo-500 text-white px-4 py-2.5 rounded-2xl flex items-center justify-center gap-2 font-semibold text-[13px] shadow-lg shadow-indigo-500/25 active:scale-[0.97] transition-transform"
              >
                <PlusIcon size={16} /> Create Warehouse
              </button>
            </div>

            {/* ================= DESKTOP HEADER (md and up) ================= */}
            <div className="hidden md:flex flex-col sm:flex-row sm:items-center items-center sm:justify-between gap-3 mb-2">
              <div className="flex items-center gap-2">
                <div className={`flex items-center justify-center w-8 h-8 rounded-lg border flex-shrink-0 transition-colors duration-300 ${isDarkMode ? 'border-gray-700 bg-[#111827]' : 'border-black/60'}`}>
                  <LuWarehouse className={`text-sm transition-colors duration-300 ${isDarkMode ? 'text-amber-500' : 'text-brown-600'}`} size={16} />
                </div>
                <div>
                  <h1 className={`text-[16px] font-bold leading-tight transition-colors duration-300 ${isDarkMode ? 'text-white' : 'text-black'}`}>
                    All Warehouses
                  </h1>
                  <p className={`text-[9px] transition-colors duration-300 ${isDarkMode ? 'text-gray-400' : 'text-black/40'}`}>
                    Manage every registered warehouse location
                  </p>
                </div>
              </div>
                {/* Search bar */}
            <div className="w-[60%]">
              <div className={`relative flex items-center border grow py-1 rounded-lg transition-colors duration-300 ${isDarkMode ? 'bg-[#111827] border-gray-700' : 'bg-white border-gray-500'}`}>
                <div className="pl-2.5 pr-2">
                  <CgSearch className={`text-sm transition-colors duration-200 ${isDarkMode ? 'text-indigo-400' : 'text-blue-600'}`} size={15} />
                </div>


                <input
                  type="text"
                  placeholder="Search by ID, phone or name"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  className={`flex-1 py-1.5 pr-2 bg-transparent outline-none text-[10px] transition-colors duration-300 ${isDarkMode ? 'text-gray-200 placeholder-gray-500' : 'text-black placeholder-black'}`}
                />

                {searchTerm && (
                  <button
                    onClick={() => handleSearchChange({ target: { value: '' } })}
                    className={`mr-2 p-0.5 rounded-full transition-colors duration-200 ${isDarkMode ? 'text-gray-400 hover:text-gray-200' : 'text-black/30 hover:text-black/60'}`}
                  >
                    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                )}
              </div>
            </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setIsAddDrawerOpen(true)}
                  className={`text-[11px] flex gap-1 items-center font-semibold px-3 py-2 rounded-lg transition-all duration-200 active:scale-[0.98] ${isDarkMode ? 'bg-white text-black hover:bg-gray-200' : 'bg-violet-600 text-white hover:bg-blue-500'}`}
                >
                  <PlusIcon size={14}/> Create Warehouse
                </button>
              </div>
            </div>

            {/* ================= MOBILE CARDS (only < md) ================= */}
            {isMobileView && (
              <div className="flex flex-col gap-3 pb-3">
                <style>{`
                  @keyframes whCardIn {
                    from { opacity: 0; transform: translateY(12px) scale(0.98); }
                    to   { opacity: 1; transform: translateY(0) scale(1); }
                  }
                  .wh-card-animate { animation: whCardIn 0.3s ease both; }
                  .wh-action-btn { transition: all 0.2s ease; }
                  .wh-action-btn:active { transform: scale(0.94); }
                `}</style>

                {displayWarehouses.length === 0 && (
                  <div className={`text-center py-16 rounded-3xl border shadow-lg ${
                    isDarkMode
                      ? 'bg-gradient-to-br from-[#0b0b14] via-[#0d0d18] to-[#0b0b14] border-indigo-500/25 text-indigo-300/60'
                      : 'bg-white border-gray-200 text-gray-400'
                  }`}>
                    <LuPackageSearch className="mx-auto mb-3 text-4xl opacity-30" />
                    <p className="font-medium text-sm">No warehouses found</p>
                    <p className="text-[11px] mt-1 opacity-70">Try adjusting your search term.</p>
                  </div>
                )}

                {displayWarehouses.map((warehouse, index) => {
                  const isActive = warehouse.status === 'Active';
                  return (
                    <div
                      key={warehouse.id}
                      className={`wh-card-animate relative rounded-3xl overflow-hidden shadow-md transition-all ${
                        isDarkMode ? 'shadow-indigo-900/20' : 'shadow-black/5'
                      }`}
                      style={{ animationDelay: `${index * 50}ms` }}
                    >
                      {/* Glass background */}
                      <div className={`absolute inset-0 ${
                        isDarkMode
                          ? 'bg-gradient-to-br from-[#0b0b14] via-[#0d0d18] to-[#0b0b14]'
                          : 'bg-white'
                      }`} />

                      {/* Top accent line */}
                      <div className={`absolute top-0 left-0 right-0 h-1 bg-gradient-to-r ${
                        isDarkMode
                          ? 'from-indigo-500/40 via-purple-500/40 to-pink-500/40'
                          : 'from-violet-400 via-indigo-400 to-purple-400'
                      }`} />

                      <div className="relative p-4">
                        {/* Header: avatar + name + status */}
                        <div className="flex items-start gap-3 mb-3">
                          <div className={`w-11 h-11 rounded-2xl flex-shrink-0 bg-gradient-to-br ${getAvatarGradient(warehouse.id || warehouse.name)} flex items-center justify-center shadow-lg shadow-black/10`}>
                            <span className="text-white text-base font-bold">
                              {warehouse.name?.toString().charAt(0).toUpperCase() || 'W'}
                            </span>
                          </div>
                          <div className="min-w-0 flex-1">
                            <div className={`font-bold text-[14px] truncate ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                              {warehouse.name}
                            </div>
                            <div className={`text-[10px] font-mono ${isDarkMode ? 'text-indigo-300/60' : 'text-gray-400'}`}>
                              ID: {warehouse.id}
                            </div>
                          </div>
                          <span className={`px-2.5 py-1 text-[10px] font-bold rounded-full border flex items-center gap-1.5 flex-shrink-0 ${
                            isActive
                              ? isDarkMode
                                ? 'bg-emerald-500/15 text-emerald-300 border-emerald-400/40'
                                : 'bg-emerald-50 text-emerald-700 border-emerald-200'
                              : isDarkMode
                                ? 'bg-gray-500/15 text-gray-300 border-gray-400/40'
                                : 'bg-gray-50 text-gray-600 border-gray-200'
                          }`}>
                            <span className={`w-1.5 h-1.5 rounded-full ${isActive ? 'bg-emerald-500' : 'bg-gray-400'}`} />
                            {warehouse.status || 'Active'}
                          </span>
                        </div>

                        {/* Contact info */}
                        <div className={`p-2.5 rounded-2xl mb-3 space-y-1.5 ${isDarkMode ? 'bg-white/[0.03]' : 'bg-gray-50'}`}>
                          {warehouse.email && (
                            <div className="flex items-center gap-2 min-w-0">
                              <span className="text-[11px]">✉️</span>
                              <span className={`text-[11px] truncate ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                {warehouse.email}
                              </span>
                            </div>
                          )}
                          {warehouse.phone && (
                            <div className="flex items-center gap-2">
                              <LuPhone size={11} className={isDarkMode ? 'text-indigo-400' : 'text-indigo-600'} />
                              <span className={`text-[11px] font-mono ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                {warehouse.phone}
                              </span>
                            </div>
                          )}
                          <div className="flex items-start gap-2 min-w-0">
                            <LuMapPin size={11} className={`flex-shrink-0 mt-0.5 ${isDarkMode ? 'text-rose-400' : 'text-red-500'}`} />
                            <span className={`text-[11px] leading-snug ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                              {[warehouse.city, warehouse.state, warehouse.country].filter(Boolean).join(', ') || '—'}
                            </span>
                          </div>
                        </div>

                        {/* Actions */}
                        <div className={`flex items-center gap-2 pt-2 border-t ${isDarkMode ? 'border-indigo-500/20' : 'border-gray-100'}`}>
                          <button
                            onClick={() => handleViewClick(warehouse)}
                            className={`wh-action-btn flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl text-xs font-semibold ${
                              isDarkMode
                                ? 'bg-indigo-500/10 text-indigo-300'
                                : 'bg-indigo-50 text-indigo-600'
                            }`}
                          >
                            <IoMdEye size={14} /> View Details
                          </button>
                          <button
                            onClick={() => handleDelete(warehouse.id)}
                            disabled={loadingWarehouseId === warehouse.id}
                            className={`wh-action-btn flex items-center justify-center gap-1.5 px-3 py-2 rounded-xl text-xs font-semibold disabled:opacity-50 ${
                              isDarkMode
                                ? 'bg-red-500/10 text-red-400'
                                : 'bg-red-50 text-red-500'
                            }`}
                          >
                            {loadingWarehouseId === warehouse.id ? (
                              <span className="animate-spin text-[12px]">⏳</span>
                            ) : (
                              <MdDelete size={14} />
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Table with scroll - FIXED (desktop only) */}
            <div className={`hidden md:flex border rounded-lg overflow-hidden flex-1 flex-col min-h-0 transition-colors duration-300 ${isDarkMode ? 'border-gray-800 bg-[#111827]' : 'border-black/30'}`}>
              {/* Scrollable table container */}
              <div className="flex-1 overflow-y-auto overflow-x-auto custom-scrollbar">
                <table className="min-w-full table-auto">
                  <thead className={`border-b sticky top-0 z-10 transition-colors duration-300 ${isDarkMode ? 'bg-[#1F2937] border-gray-800' : 'bg-violet-700 border-black/10'}`}>
                    <tr>
                      <th className={`px-2.5 py-1.5 text-left text-[12px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-gray-300' : 'text-white'}`}>Warehouse</th>
                      <th className={`px-2.5 py-1.5 text-left text-[12px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-gray-300' : 'text-white'}`}>Contact</th>
                      <th className={`px-2.5 py-1.5 text-left text-[12px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-gray-300' : 'text-white'}`}>Location</th>
                      <th className={`px-2.5 py-1.5 text-left text-[12px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-gray-300' : 'text-white'}`}>Status</th>
                      <th className={`px-2.5 py-1.5 text-right text-[12px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-gray-300' : 'text-white'}`}>Actions</th>
                    </tr>
                  </thead>
                  <tbody className={`divide-y transition-colors duration-300 ${isDarkMode ? 'divide-gray-800 bg-[#111827]' : 'bg-white'}`}>
                    {displayWarehouses.length === 0 ? (
                      <tr>
                        <td colSpan={5} className="py-6">
                          <div className="flex flex-col items-center justify-center text-center gap-1.5">
                            <div className={`flex items-center justify-center w-9 h-9 rounded-lg ${isDarkMode ? 'bg-[#1F2937]' : 'bg-white'}`}>
                              <LuPackageSearch size={16} className={isDarkMode ? 'text-gray-500' : 'text-black/30'} />
                            </div>
                            <p className={`text-[10px] font-semibold ${isDarkMode ? 'text-gray-400' : 'text-black/60'}`}>
                              No warehouses found
                            </p>
                            <p className={`text-[8px] ${isDarkMode ? 'text-gray-500' : 'text-black/30'}`}>
                              Try adjusting your search term.
                            </p>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      displayWarehouses.map((warehouse) => (
                        <tr
                          key={warehouse.id}
                          className={`transition-colors duration-150 ${isDarkMode ? 'hover:bg-[#1F2937]/80' : 'hover:bg-black/5'}`}
                        >
                          <td className="px-2.5 py-1.5">
                            <div className="flex items-center gap-2">
                              <div className={`flex items-center justify-center w-7 h-7 rounded-lg text-[12px] font-bold flex-shrink-0 transition-colors duration-300 ${isDarkMode ? 'bg-gray-800 text-white' : 'bg-violet-700 text-white'}`}>
                                {warehouse.name?.toString().charAt(0).toUpperCase() || 'W'}
                              </div>
                              <div className="min-w-0">
                                <p className={`text-[12px] font-semibold truncate ${isDarkMode ? 'text-gray-200' : 'text-black'}`}>
                                  {warehouse.name}
                                </p>
                                <p className={`text-[8px] ${isDarkMode ? 'text-gray-400' : 'text-black/80'}`}>
                                  ID: {warehouse.id}
                                </p>
                              </div>
                            </div>
                          </td>
                          <td className="px-2.5 py-1.5">
                            <p className={`text-[12px] truncate max-w-[160px] ${isDarkMode ? 'text-gray-300' : 'text-black/70'}`}>
                              {warehouse.email}
                            </p>
                            <p className={`flex items-center gap-0.5 text-[12px] font-mono mt-0.5 ${isDarkMode ? 'text-gray-400' : 'text-black'}`}>
                              <LuPhone size={10} className={isDarkMode ? 'text-indigo-400' : 'text-blue-600'} />
                              {warehouse.phone}
                            </p>
                          </td>
                          <td className="px-2.5 py-1.5">
                            <p className={`flex items-center gap-0.5 text-[12px] ${isDarkMode ? 'text-gray-300' : 'text-black/70'}`}>
                              <LuMapPin size={10} className={`flex-shrink-0 ${isDarkMode ? 'text-rose-400' : 'text-red-500'}`} />
                              {[warehouse.city, warehouse.state, warehouse.country].filter(Boolean).join(', ')}
                            </p>
                          </td>
                          <td className="px-2.5 py-1.5">
                            <span className={`inline-flex items-center px-1.5 py-0.5 rounded-full text-[12px] font-medium transition-colors duration-300 ${warehouse.status === 'Active'
                              ? isDarkMode ? 'bg-gray-800 text-gray-200 border border-gray-700' : 'bg-green-600/10 text-black'
                              : isDarkMode ? 'bg-gray-800/50 text-gray-400 border border-gray-700' : 'bg-white shadow-xl border border-gray-400 text-black/60'
                              }`}>
                              <span className={`w-1.5 h-1.5 rounded-full mr-1 ${warehouse.status === 'Active'
                                ? isDarkMode ? 'bg-green-400' : 'bg-black'
                                : isDarkMode ? 'bg-gray-500' : 'bg-green-600'
                                }`}></span>
                              {warehouse.status || 'Active'}
                            </span>
                          </td>
                          <td className="px-2.5 py-1.5">
                            <div className="flex items-center justify-end gap-1">
                              <button
                                onClick={() => handleViewClick(warehouse)}
                                aria-label="View warehouse"
                                className={`p-1 rounded-lg transition-colors ${isDarkMode ? 'hover:bg-gray-700' : 'hover:bg-black/10'}`}
                              >
                                <IoMdEye size={14} className={isDarkMode ? 'text-sky-400' : 'text-blue-600'} />
                              </button>
                              <button
                                onClick={() => handleDelete(warehouse.id)}
                                aria-label="Delete warehouse"
                                disabled={loadingWarehouseId === warehouse.id}
                                className={`p-1 rounded-lg transition-colors ${isDarkMode ? 'hover:bg-red-900/20' : 'hover:bg-black/10'} disabled:opacity-40`}
                              >
                                {loadingWarehouseId === warehouse.id ? (
                                  <span className={`animate-spin text-[10px] ${isDarkMode ? 'text-white' : 'text-black'}`}>⏳</span>
                                ) : (
                                  <MdDelete size={14} className={isDarkMode ? 'text-rose-500' : 'text-red-500'} />
                                )}
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* Footer: count, page size, pagination - fixed at bottom */}
              <div className={`flex flex-col sm:flex-row justify-between items-center gap-2 px-3 py-2 border-t flex-shrink-0 transition-colors duration-300 ${isDarkMode ? 'border-gray-800 bg-[#111827]' : 'border-black/10'}`}>
                <span className={`text-[12px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-black/40'}`}>
                  {`Total Warehouses: ${totalOrders}`}
                </span>

                <div className="flex items-center gap-2">
                  <select
                    id="limit"
                    value={limit}
                    onChange={handleLimitChange}
                    className={`border rounded-lg px-1.5 py-1 text-[12px] outline-none focus:ring-1 transition-colors duration-300 ${isDarkMode ? 'bg-[#1F2937] border-gray-700 text-gray-200 focus:ring-gray-500' : 'bg-white border-black/20 text-black focus:ring-black/50'}`}
                    disabled={totalOrders < 10}
                  >
                    {totalOrders === 0 ? (
                      <option value={0}>0</option>
                    ) : (
                      <>
                        <option value={10}>10</option>
                        <option value={15}>15</option>
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                        <option value={totalOrders}>All</option>
                      </>
                    )}
                  </select>

                  <Pagination
                    count={Math.ceil(totalOrders / limit)}
                    page={currentPage}
                    onChange={handlePaginationChange}
                    variant="outlined"
                    shape="rounded"
                    size="small"
                    renderItem={(item) => (
                      <PaginationItem
                        {...item}
                        sx={{
                          borderRadius: '6px',
                          color: isDarkMode ? '#E5E7EB' : '#000000',
                          borderColor: isDarkMode ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
                          '&.Mui-selected': {
                            backgroundColor: isDarkMode ? '#374151' : '#722F99',
                            color: '#ffffff',
                            borderColor: isDarkMode ? '#4B5563' : '#000000',
                          },
                          '&:hover': {
                            backgroundColor: isDarkMode ? '#4B5563' : '#F3F4F6',
                          }
                        }}
                      />
                    )}
                  />
                </div>
              </div>
            </div>

            {/* ================= MOBILE FOOTER (only < md) ================= */}
            {isMobileView && totalOrders > 0 && (
              <div className={`mt-3 flex items-center justify-between gap-2 px-3 py-2.5 rounded-2xl border ${
                isDarkMode
                  ? 'bg-[#141425] border-indigo-500/25'
                  : 'bg-white border-gray-200'
              }`}>
                <div className={`text-[11px] font-medium ${isDarkMode ? 'text-indigo-300/70' : 'text-gray-500'}`}>
                  {totalOrders} total
                </div>
                <Pagination
                  count={Math.ceil(totalOrders / limit)}
                  page={currentPage}
                  onChange={handlePaginationChange}
                  variant="outlined"
                  shape="rounded"
                  size="small"
                  renderItem={(item) => (
                    <PaginationItem
                      {...item}
                      sx={{
                        borderRadius: '8px',
                        fontSize: '11px',
                        minWidth: '26px',
                        height: '26px',
                        color: isDarkMode ? '#c7d2fe' : '#000000',
                        borderColor: isDarkMode ? 'rgba(99,102,241,0.4)' : 'rgba(0,0,0,0.15)',
                        '&.Mui-selected': {
                          backgroundColor: isDarkMode ? '#4f46e5' : '#722F99',
                          color: '#ffffff',
                          borderColor: isDarkMode ? '#6366f1' : '#000000',
                        },
                        '&:hover': {
                          backgroundColor: isDarkMode ? '#4B5563' : '#F3F4F6',
                        }
                      }}
                    />
                  )}
                />
              </div>
            )}
          </div>
        </div>

        <ViewWarehouse isopen={isPopupOpen} onClose={handleClose} warehouse={selectedWarehouse} />

        {/* NEW: Right-side "Add Warehouse" drawer */}
        <div
          className={`fixed inset-0 z-[60] transition-opacity duration-300 ${isAddDrawerOpen ? 'opacity-100 pointer-events-auto' : 'opacity-10 pointer-events-none'}`}
        >
          {/* backdrop */}
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setIsAddDrawerOpen(false)}
          />

          {/* sliding panel */}
          <div
            className={`absolute top-0 right-0 h-full w-full sm:w-[35%] overflow-y-auto shadow-2xl rounded-l-xl transform transition-transform duration-300 ease-in-out ${isAddDrawerOpen ? 'translate-x-0' : 'translate-x-full'} ${isDarkMode ? 'bg-[#111827]' : 'bg-white'}`}
          >
            <div className={`flex items-center justify-between px-3 py-2.5 border-b sticky top-0 z-10 transition-colors duration-300 ${isDarkMode ? 'bg-[#1F2937] border-gray-700' : 'bg-white border-black/10'}`}>
              <h2 className={`text-[13px] font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>Add New Warehouse</h2>
              <button
                onClick={() => setIsAddDrawerOpen(false)}
                aria-label="Close"
                className={`p-1.5 rounded-lg transition-colors ${isDarkMode ? 'hover:bg-gray-700 text-gray-300' : 'hover:bg-black/10 text-black'}`}
              >
                <IoClose size={16} />
              </button>
            </div>

            {isAddDrawerOpen && (
              <AddWarehousePopup
                onClose={() => setIsAddDrawerOpen(false)}
                onSuccess={handleAddSuccess}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AllWarehouses;